module.exports = __webpack_public_path__ + "img/honor (8).a35b8d54.jpg";